<template>
	<InertiaHead>
        <title>{{ meta?.meta_title }}</title>
        <meta name="description" :content="meta?.meta_description" />
        <meta property="og:image" :content="meta?.meta_image_path" />
    </InertiaHead>

    <div class="relative">

    	<!--
    	<div class="w-full p-3 text-sm md:text-base text-center font-medium bg-[#C72B50] text-white">
    		{{ __('home::index.promotion') }}
    	</div>
    	-->

    	<!--
    	<div class="w-full p-3 text-sm md:text-base text-center font-medium bg-gray-200 text-black" v-if="delayedPaymentDays">
    		{{ __('home::index.promotion_delayed_payment_days', { days: delayedPaymentDays }) }}
    	</div>
    	-->

        <section
            v-if="$page.props.__site.promotion_banner"
            :class="[$page.props.__site.promotion_style === 'black_friday'
                ? 'bg-black text-[#ffd732] font-bold'
                : 'bg-primary-light text-primary font-bold'
            ]"
        >
            <div
                class="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 text-center py-1 md:py-2 text-base whitespace-pre-line sm:whitespace-normal"
                v-html="getRenderedPromotionBannerText()"
            />
        </section>

    	<ClientOnly>
			<Popover
                open="true"
                class="sticky top-0 z-20 bg-white border-b border-transparent"
                :class="[headerIsStuck ? 'shadow-sm border-gray-100' : '']"
            >
				<div
                    class="w-full max-w-screen-xl mx-auto flex justify-between items-center px-6 py-5 xl:justify-start xl:space-x-10"
                    ref="header"
                >
					<div>
						<InertiaLink :href="$route('home::pages.index')" class="flex">
							<span class="sr-only">{{ $page.props.__site.name }}</span>
							<img class="h-8 w-auto sm:h-10" :src="'/media/' + $page.props.__media_folder + '/logo.svg'" alt="" />
						</InertiaLink>
					</div>
					<div class="-mr-2 -my-2 xl:hidden">
						<div class="flex justify-between items-center gap-2">
                            <TrustpilotScore />
                            <!--
							<button type="button" @click="toggleChat" class="flex items-center text-gray-500 text-base font-medium hover:text-gray-900 mr-4">
								{{ __('home::nav.chat_with_us') }}
							</button>
							-->

							<PopoverButton class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-light">
								<span class="sr-only">Open menu</span>
								<MenuIcon class="h-6 w-6" aria-hidden="true" />
							</PopoverButton>
						</div>
					</div>
					<div class="hidden xl:flex-1 xl:flex xl:items-center xl:justify-between">
						<div class="flex space-x-10">
							<InertiaLink v-for="(item, index) in navigation" :key="item.name" :href="item.href" :class="[item.current ? 'text-gray-900' : 'text-gray-500', 'text-base font-medium hover:text-gray-900']">
								{{ item.name }}
							</InertiaLink>
						</div>
						<div class="flex items-center xl:ml-12">
                            <!--
							<button type="button" @click="toggleChat" class="flex items-center text-gray-500 text-base font-medium hover:text-gray-900">
								<ChatIcon class="inline-block w-6 h-6 mr-2" />
								<span class="inline-block leading-none pt-[1px]">
									{{ __('home::nav.chat_with_us') }}
								</span>
							</button>
							-->

							<InertiaLink :href="$route('home::orders.create')" class="ml-8 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-sm shadow-sm text-base font-medium text-white bg-primary-light text-primary hover:shadow-lg transition-all">
								{{ __('home::nav.order_now') }}
							</InertiaLink>
						</div>
					</div>
				</div>

				<transition enter-active-class="duration-200 ease-out" enter-from-class="opacity-0 scale-95" enter-to-class="opacity-100 scale-100" leave-active-class="duration-100 ease-in" leave-from-class="opacity-100 scale-100" leave-to-class="opacity-0 scale-95">
					<PopoverPanel focus class="absolute top-0 z-50 inset-x-0 p-2 transition transform origin-top-right xl:hidden">
						<div class="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
							<div class="pt-5 pb-6 px-5">
								<div class="flex items-center justify-between">
									<div>
										<img class="h-8 w-auto" :src="'/media/' + $page.props.__media_folder + '/logo.svg'" alt="Fototiles" />
									</div>

									<div class="-mr-2">
										<PopoverButton class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-light">
											<span class="sr-only">Close menu</span>
											<XIcon class="h-6 w-6" aria-hidden="true" />
										</PopoverButton>
									</div>
								</div>
							</div>
							<div class="py-6 px-5">
								<div class="space-y-4">
									<InertiaLink v-for="(item, index) in navigation" :key="item.name" :href="item.href" class="block truncate" :class="[item.current ? 'text-gray-900' : 'text-gray-500', 'text-base font-medium hover:text-gray-900']">
										{{ item.name }}
									</InertiaLink>
								</div>
								<div class="mt-6">
									<InertiaLink :href="$route('home::orders.create')" class="w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary hover:shadow-lg transition-all">
										{{ __('home::nav.order_now') }}
									</InertiaLink>
								</div>
							</div>
						</div>
					</PopoverPanel>
				</transition>
			</Popover>
		</ClientOnly>

		<slot></slot>

		<footer class="sm:mt-16">
            <div class="bg-gray-200 pt-8 border-t border-gray-300">
                <div class="relative max-w-7xl mx-auto px-4 sm:px-6 xl:px-8">
                    <img src="/media/footer-employee.avif" alt="Support" class="hidden sm:block absolute bottom-0 left-3 sm:left-6 lg:left-8 w-36 h-36 md:w-[17rem] md:h-[17rem]" />

                    <div class="sm:pl-36 md:pl-[17rem] sm:pb-8">
                        <div class="text-2xl font-bold text-center">{{ __('home::footer.support_title') }}</div>

                        <div class="flex gap-8 xs:items-center mt-6 xs:mt-8">
                            <div class="flex justify-center flex-grow">
                                <div class="grid gap-x-4 gap-y-2 items-start" :class="[$page.props.__site.phone ? 'lg:grid-cols-3' : 'lg:grid-cols-2']">
                                    <div class="flex lg:flex-col lg:justify-center items-center gap-3 lg:gap-2 col-span-1" v-if="$page.props.__site.phone">
                                        <PhoneOutgoingIcon class="w-5 h-5 lg:w-8 lg:h-8" />
                                        <div class="flex lg:flex-col items-center lg:justify-center text-center gap-1">
                                            <a :href="'tel:' + $page.props.__site.phone.replaceAll(' ', '')" class="text-lg font-bold">{{ $page.props.__site.phone }}</a>
                                            <div class="hidden lg:block">{{ __('home::footer.phone_contact_info') }}</div>
                                        </div>
                                    </div>

                                    <div class="flex lg:flex-col lg:justify-center items-center gap-3 lg:gap-2 col-span-1" v-if="$page.props.__site.email">
                                        <MailIcon class="w-5 h-5 lg:w-8 lg:h-8" />
                                        <div class="flex lg:flex-col items-center lg:justify-center text-center gap-1">
                                            <a :href="'mailto:' + $page.props.__site.email" class="text-lg font-bold">{{ $page.props.__site.email }}</a>
                                            <div class="hidden lg:block">{{ __('home::footer.email_contact_info') }}</div>
                                        </div>
                                    </div>

                                    <div class="flex lg:flex-col lg:justify-center items-center gap-3 lg:gap-2 col-span-1">
                                        <UserGroupIcon class="w-5 h-5 lg:w-8 lg:h-8" />
                                        <div class="flex lg:flex-col items-center lg:justify-center text-center gap-1">
                                            <div class="text-lg font-bold">{{ __('home::footer.customer_amount_title') }}</div>
                                            <div class="hidden lg:block">{{ __('home::footer.customer_amount_info') }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mx-auto max-w-[400px] h-20 relative flex pl-24 sm:hidden mt-6">
                        <img src="/media/footer-employee.avif" alt="Support" class="absolute bottom-0 left-1 h-20" />
                        <div class="text-sm leading-tight py-3">{{ __('home::footer.support_info') }}</div>
                    </div>

                </div>
            </div>

            <div class="bg-gray-50 border-t border-gray-300">
                <div class="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 xl:px-8">
                    <nav class="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">

                        <div class="px-5 py-2" v-for="(item, index) in footerNavigation" :key="item.name">
                            <InertiaLink :href="item.href" class="text-base font-medium text-gray-500 hover:text-gray-900">
                                {{ item.name }}
                            </InertiaLink>
                        </div>
                    </nav>
                    <div class="mt-8 flex justify-center space-x-6">
                        <a :href="$page.props.__site.facebook_link" target="_blank" class="text-gray-400 hover:text-gray-500">
                            <span class="sr-only">Facebook</span>
                            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" />
                            </svg>
                        </a>

                        <a :href="$page.props.__site.instagram_link" target="_blank" class="text-gray-400 hover:text-gray-500">
                            <span class="sr-only">Instagram</span>
                            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd" />
                            </svg>
                        </a>
                    </div>
                    <p class="mt-8 text-center text-base text-gray-400">
                        &copy; {{ __('home::footer.copyright') }}
                    </p>
                    <div class="mt-8 text-center">
                        <img src="/media/payment-cards.png" class="inline-block h-8" v-if="$page.props.__site.payment_methods.includes('card')" />
                        <img src="/media/payment-mobilepay.png" class="inline-block h-8" v-if="$page.props.__site.payment_methods.includes('mobilepay')" />
                        <img src="/media/delivery-bring.svg" class="inline-block h-8 p-2" />
                    </div>
                </div>
            </div>
		</footer>

	</div>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import {
    ChatIcon,
    MenuIcon,
    XIcon,
    MailIcon,
    PhoneOutgoingIcon,
    UserGroupIcon,
} from '@heroicons/vue/outline'

export default {
    components: {
        ChatIcon,
        Popover,
        PopoverButton,
        PopoverPanel,
        MenuIcon,
        XIcon,
        MailIcon,
        PhoneOutgoingIcon,
        UserGroupIcon,
    },
    props: {
        meta: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            navigation: this.$page.props.__navigation,
            footerNavigation: this.$page.props.__footerNavigation,
            user: this.$page.props.auth.user,
            delayedPaymentDays: this.$cookies.get('cp_dpd'),
            headerIsStuck: false,
        }
    },
    methods: {
        toggleChat() {
            FB.CustomerChat.show(true);
        },
        getRenderedPromotionBannerText() {
            let text = this.$page.props.__site.promotion_banner;

            const firstDashIndex = text.indexOf("-");
            const secondDashIndex = text.indexOf("-", firstDashIndex + 1);

            if (secondDashIndex === -1) {
                return text;
            }

            return text.slice(0, secondDashIndex) + '\n<span class="hidden sm:inline-block">-</span>' + text.slice(secondDashIndex + 1);
        },
    },
    mounted() {
        window?.addEventListener('scroll', () => {
            let rect = this.$refs.header.getBoundingClientRect();
            let top = rect ? rect.top : 0;
            this.headerIsStuck = rect ? rect.top === 0 : false;
        });
    }
}
</script>
